import { Outlet } from "react-router-dom";
import "./index.scss";
import Navbar from "../Navbar";
import ScrollToTop from "../ScrollToTop";

const Layout = () => {
  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <ScrollToTop />
    </>
  );
};

export default Layout;
